import {
  Component,
  forwardRef,
  Input,
} from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";

export interface TriggerModeOption {
  label: string;
  value: string;
}

@Component({
  selector: "app-trigger-mode-radio-group",
  templateUrl: "./trigger-mode-radio-group.component.html",
  styleUrls: ["./trigger-mode-radio-group.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TriggerModeRadioGroupComponent),
      multi: true,
    },
  ],
})
export class TriggerModeRadioGroupComponent implements ControlValueAccessor {
  @Input() options: TriggerModeOption[] = [];

  value: string | null = null;
  disabled = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string | null): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  select(value: string): void {
    if (this.disabled) return;
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
